import { useCallback } from "react";
import {
  getCCAFieldDefinitions,
  getExistingCodes,
} from "../../../api/AnalysisCodes";
import { useWorkOrderStore } from "../../../store/wo-order";

type Props = {
  woEventDateCreated: string;
  woEventTimeCreated: string;
  woEquipment: string;
  woNumber: string;
};

export default function useGetIsCAARequiredForCompletion() {
  const setCaaIsRequiredForWoCompletion = useWorkOrderStore(
    (state) => state.setCaaIsRequiredForWoCompletion
  );

  const getIsCAARequiredForCompletion = useCallback(
    async (data: Props) => {
      const { woEquipment, woEventDateCreated, woEventTimeCreated, woNumber } =
        data;
      const fields = await getCCAFieldDefinitions(woEquipment);
      let existingCodes: any[] = [];
      if (woEventDateCreated && woEventTimeCreated) {
        existingCodes =
          (await getExistingCodes(woEventDateCreated, woEventTimeCreated)) ||
          [];
      }
      const isCaaRequired = !!(
        fields &&
        (fields.componentField?.IsRequired ||
          fields.actionField?.IsRequired ||
          fields.conditionField?.IsRequired) &&
        existingCodes.length === 0
      );

      setCaaIsRequiredForWoCompletion(woNumber, isCaaRequired);

      return isCaaRequired;
    },
    [setCaaIsRequiredForWoCompletion]
  );

  return { getIsCAARequiredForCompletion };
}
